import { SwUpdate } from '@angular/service-worker';
import { Subscription } from 'rxjs';
import { CacheService } from './cache.service';
import { AppConfigService } from '../app-config.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PromptUpdateService {
  isNewVersionAvailable: boolean = false;
  newVersionSubscription: Subscription;
  constructor(
    private swUpdate: SwUpdate,
    private cacheService: CacheService,
    private appConfig: AppConfigService
  ) {
    this.checkForUpdate();
  }
  checkForUpdate(): void {
    if (this.appConfig.hasServiceWorker()) {
      let me = this;
      this.newVersionSubscription?.unsubscribe();
      this.newVersionSubscription = this.swUpdate.versionUpdates
        .subscribe(evt => {
          switch (evt.type) {
            case 'VERSION_DETECTED':
              console.log(`Downloading new app version: ${evt.version.hash}`);
              break;
            case 'VERSION_READY':
              console.log(`Current app version: ${evt.currentVersion.hash}`);
              console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
              me.cacheService.clearCacheAll();
              document.location.reload();
              break;
            case 'VERSION_INSTALLATION_FAILED':
              console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
              break;
          }
          if ("latestVersion" in evt) {
            console.log(`New app version ready for use: '${evt.latestVersion.hash}'`);
          }
        });
    }
  }

}
